<button
  class="submit-button"
  mat-flat-button
  type="submit"
  [color]="color"
  [disabled]="form?.pristine || form?.invalid || isLoading || isDisabled"
  fxLayoutAlign="center center"
  e
>
  @if (isLoading) {
  <mat-progress-spinner diameter="26" strokeWidth="2" mode="indeterminate" color="accent"></mat-progress-spinner>
  } @else {
  <ng-content></ng-content>
  }
</button>
